import { FreeSpinsRainbowOverlayProperties } from "@lib/js-slingo-pawnshop-core/dist/game/view/abstract/properties/FreeSpinsRainbowOverlayProperties";
export class FreeSpinsRainbowOverlayLandscapeProperties extends FreeSpinsRainbowOverlayProperties {
    setDefaultValues() {
        super.setDefaultValues();
    }
}
